// Écrans réservés aux admins — §3 du contrat gelé
// `CONTRACT-AUTHENTIFICATION.md` (racine du repo, section « La frontière »).
//
// Source de vérité canonique côté serveur : `apps/api/src/config/acces.ts`
// (hors frontière de cet agent — cf. §6ter, bloc A). Cette copie sert
// UNIQUEMENT à masquer des onglets par confort : l'API vérifie l'accès de
// son côté et renvoie 403 indépendamment. Ne rien construire de sécuritaire
// sur cette liste côté navigateur.
const ECRANS_RESERVES_ADMIN = new Set<string>([
  'bilans-fournisseurs', // couvre aussi 'bilans-fournisseurs/:idFour'
  'vue-fournisseurs',
  'pilotage-achats',
  'kpi-entrepot',
  'verite-factures',
  'admin', // Réglages
  'analyse-docs', // réfutation 06/08 — gestes opérationnels (valider ligne IA, profil fournisseur)
  'fournisseurs', // couvre aussi 'fournisseurs/:idSupplier' — module Fournisseurs (GO Ben 22/08), API réservée admin
  'logistique', // couvre 'logistique/factures/:id' et 'logistique/tableau-de-bord' — factures du 3PL et rentabilité (spec 19/10, tout le module admin)
]);

/** `modulePath` est le `path` d'un ModuleRoute, ex. 'bilans-fournisseurs/:idFour'. */
export function estReserveAuxAdmins(modulePath: string): boolean {
  const segmentRacine = modulePath.split('/')[0] ?? modulePath;
  return ECRANS_RESERVES_ADMIN.has(segmentRacine);
}
